/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable jquery-unsafe/no-html */
import iframeContentLoader from '@intercom/embercom-composer/lib/iframe-content-loader';
import InlinedTemplateGenerator from '@intercom/embercom-composer/lib/inlined-template-generator';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import Em from 'ember';
const INLINE_ELEMENTS = '<a href="#">Link</a> ' + '<b>Bold</b> ' + '<i>Italic</i> ' + '<b><i>Bold Italic</i></b> ' + '<a href="#"><b>Bold Link</b></a> ' + '<a href="#"><i>Italic Link</i></a> ' + '<a href="#"><b><i>Bold Italic Link</i></b></a>';
const DEFAULT_CONTENT_HTML = `${'<div id="ic-template-content" contenteditable>' + '<h1>Heading'}${INLINE_ELEMENTS}</h1>` + `<h2>Subheading ${INLINE_ELEMENTS}</h2>` + `<p>Paragraph ${INLINE_ELEMENTS}</p>` + `<pre>Code</pre>` + `<ul><li>Ordered List ${INLINE_ELEMENTS}</li></ul>` + `<ol><li>Unordered List ${INLINE_ELEMENTS}</li></ol>` + `<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAGklEQVQIW2NkgID/QMwIo2EMqByEAglSoBIAqSUIBKGB5rgAAAAASUVORK5CYII=">` + `<iframe contenteditable=false width="100%"></iframe>` + `</div>`;
function TemplateStyleTransformer() {
  this.currentTemplate = '';
  this.currentIframe = '';
  this.generator = new InlinedTemplateGenerator('.embercom-composer-editor');
  this.cache = [];
}
TemplateStyleTransformer.prototype = {
  processTemplate(templateIdentifier, templateHtml, contentHtml) {
    let self = this;
    this._switchCurrent(templateIdentifier);
    return new Em.RSVP.Promise(function (resolve) {
      if (self.currentTemplate) {
        resolve(self.currentTemplate);
        return;
      }
      self._generateNewTransformedTemplateAndIframe(templateIdentifier, templateHtml, contentHtml).then(function (transformedHtml) {
        resolve(transformedHtml);
      });
    });
  },
  processContent(contentHtml) {
    if (!this.currentTemplate) {
      return contentHtml;
    }
    let $iframe = $(this.currentIframe);
    $iframe.contents().find('#ic-blocks-content').html(sanitizeHtml(contentHtml, {
      config: 'email'
    }).string);
    return this.generator.process(this.currentIframe, {
      inlineStartSelector: '.ic-blocks-html',
      ignoredElements: ['ic-attribute', 'ic-attribute span']
    });
  },
  clearCache() {
    this.cache = [];
  },
  clearCacheForId(id) {
    this.cache = this.cache.rejectBy('id', id);
  },
  _generateNewTransformedTemplateAndIframe(templateIdentifier, templateHtml, contentHtml) {
    let self = this;
    let templateWithContentHtml = this._insertContentHtml(templateHtml, contentHtml);
    return new Em.RSVP.Promise(function (resolve) {
      self._createIframeWithTemplate(templateWithContentHtml, templateIdentifier).then(function (iframe) {
        let transformedTemplate = self.generator.process(iframe);
        self._addToCache(templateIdentifier, transformedTemplate, iframe);
        self._setCurrent(transformedTemplate, iframe);
        resolve(transformedTemplate);
      });
    });
  },
  _switchCurrent(id) {
    let cachedTemplate = this.cache.findBy('id', id);
    this.currentTemplate = cachedTemplate ? cachedTemplate.template : '';
    this.currentIframe = cachedTemplate ? cachedTemplate.iframe : null;
  },
  _createIframeWithTemplate(templateHtml, id) {
    if (this._isMobileTemplate(id)) {
      return this._createMobileIframe(templateHtml);
    }
    return this._createDesktopIframe(templateHtml);
  },
  _createDesktopIframe(template) {
    return iframeContentLoader(template, 660);
  },
  _isMobileTemplate(templateId) {
    return templateId && templateId.indexOf('-mobile') > -1;
  },
  _createMobileIframe(template) {
    return iframeContentLoader(template, 320);
  },
  _insertContentHtml(template, contentHtml) {
    contentHtml = contentHtml || DEFAULT_CONTENT_HTML;
    template = template.replace(/\{\{\s*content\s*\}\}/, '{{content}}<div id="ic-blocks-content"></div>');
    return template.replace(/\{\{\s*content\s*\}\}/, contentHtml);
  },
  _setCurrent(template, iframe) {
    this.currentTemplate = template;
    this.currentIframe = iframe;
  },
  _addToCache(id, template, iframe) {
    this.cache.pushObject({
      id,
      template,
      iframe
    });
  }
};
export default TemplateStyleTransformer;